import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

interface Props {
  venueName: string
  street: string
  zip: string
  city: string
}

const FriendUpcomingParticipationAddress = ({ venueName, street, zip, city }: Props) => {
  return (
    <Stack gap={1}>
      <Text sx={{ fontWeight: 'bold', color: 'midnight' }}>{venueName}</Text>
      <Text>
        {street}, {zip} {city}
      </Text>
    </Stack>
  )
}

export default FriendUpcomingParticipationAddress
